module.exports = __webpack_public_path__ + "img/logo.2d27fb3b.png";